{
  "en": {
    "answers": [
      {
        "id": 1329064,
        "text": "Courses, Live Event, Exam",
        "is_right": true
      }
    ],
    "tags": [
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156081,
        "name": "Freetext"
      }
    ],
    "text": "Which three functions does QuizAcademy offer?",
    "is_poll_question": false,
    "type": 3,
    "created_at": "2025-09-02T15:00:43.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:26.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_score": 3,
    "max_num_characters": 200,
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "### QuizAcademy offers three core functions:\n\n#### Courses\n  **Digital self-learning module** with quiz questions and flashcards\n *(flexible, mobile, independent of time and place)*\n\n#### Live Event\n  **Gamification and survey** feature for your events\n  *(usable in both online and in-person formats)*\n\n#### Exam\n  **Function for performance assessment and survey collection**\n  *(usable both synchronously and asynchronously)*",
    "has_explanation": true,
    "num_answers": 1
  },
  "de": {
    "answers": [
      {
        "id": 1329055,
        "text": "Kurse, Live-Event, Examen",
        "is_right": true
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 27769,
        "name": "Freitext"
      }
    ],
    "text": "Welche **drei Funktionen** bietet QuizAcademy?",
    "is_poll_question": false,
    "type": 3,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:20:29.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "max_score": 3,
    "max_num_characters": 200,
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "### Musterantwort:\nKurse, Live-Event, Examen\n\n### QuizAcademy bietet drei zentrale Funktionen:\n\n#### Kurse  \n**Digitales Selbstlernmodul** mit Quizfragen und Karteikarten  \n*(flexibel, mobil, orts- und zeitunabhängig)*\n\n#### Live-Event  \n**Gamification- und Umfrage-Funktion** für Deine Veranstaltung  \n*(einsetzbar in Online- und Präsenzformaten)*\n\n#### Examen  \n**Funktion zur Leistungsbewertung und Umfrageerhebung**  \n*(sowohl synchron als auch asynchron nutzbar)*",
    "has_explanation": true,
    "num_answers": 1
  }
}
